import PFAStep from "./steps/PFAStep";
import BeneficiarStep from "./steps/BeneficiarStep";
import ObiectStep from "./steps/ObiectStep";
import FinanciarStep from "./steps/FinanciarStep";
import DurataClauzeStep from "./steps/DurataClauzeStep";
import PreviewStep from "./steps/PreviewStep";
import buildColaborarePFAPDF from "./buildPDF";

const colaborarePFAConfig = {
  buildPDF: buildColaborarePFAPDF,
  title: "Contract de Colaborare PFA Model 2026 (PDF)",
  subtitle: "Completeaza datele si genereaza un contract de colaborare PFA conform legislatiei din Romania",
  step1Benefit: "Protecție legală pentru colaborări independente",
  pdfFilename: "contract-colaborare-pfa.pdf",
  steps: [
    { id: "pfa", label: "PFA", title: "Datele PFA-ului (Prestator)", icon: "\u{1F477}", component: PFAStep },
    { id: "beneficiar", label: "Beneficiar", title: "Datele Beneficiarului", icon: "\u{1F464}", component: BeneficiarStep },
    { id: "obiect", label: "Servicii", title: "Obiectul Colaborarii", icon: "\u{1F4CB}", component: ObiectStep },
    { id: "financiar", label: "Financiar", title: "Conditii Financiare", icon: "\u{1F4B6}", component: FinanciarStep },
    { id: "durataClauze", label: "Durata & Clauze", title: "Durata si Conditii", icon: "\u{1F4DD}", component: DurataClauzeStep },
    { id: "preview", label: "Preview", title: "Previzualizare Contract", icon: "\u{1F4C4}", component: PreviewStep },
  ],
  defaultData: {
    pfaDenumire: "",
    pfaCUI: "",
    pfaSediu: "",
    pfaTitular: "",
    pfaCNP: "",
    pfaCI: "",
    beneficiarPF: false,
    beneficiarNume: "",
    beneficiarCNP: "",
    beneficiarCI: "",
    beneficiarAdresa: "",
    beneficiarDenumire: "",
    beneficiarCUI: "",
    beneficiarRegCom: "",
    beneficiarSediu: "",
    beneficiarReprezentant: "",
    obiectContract: "",
    tarifSuma: "",
    tarifMoneda: "RON",
    tipTarif: "luna",
    termenPlata: "factura30",
    durataNedeterminata: false,
    dataInceput: "",
    dataSfarsit: "",
    preavizReziliere: "30",
    includeNDA: false,
    includeNonCompete: false,
    nonCompeteDurata: "6 luni",
    nonCompeteDomeniu: "",
    transferPI: false,
  },
  validate: (stepId, data) => {
    const errors = {};

    if (stepId === "pfa") {
      if (!data.pfaDenumire.trim()) errors.pfaDenumire = "Denumirea PFA este obligatorie";
      if (!data.pfaCUI.trim()) errors.pfaCUI = "CUI-ul este obligatoriu";
      if (!data.pfaSediu.trim()) errors.pfaSediu = "Sediul profesional este obligatoriu";
      if (!data.pfaTitular.trim()) {
        errors.pfaTitular = "Numele titularului este obligatoriu";
      } else if (data.pfaTitular.trim().split(/\s+/).length < 2) {
        errors.pfaTitular = "Introduceti numele complet (nume si prenume)";
      }
      if (data.pfaCNP.trim() && !/^\d{13}$/.test(data.pfaCNP.trim())) {
        errors.pfaCNP = "CNP-ul trebuie sa contina exact 13 cifre";
      }
      if (data.pfaCI.trim() && !/^[A-Z]{2}\s?\d{6,7}$/i.test(data.pfaCI.trim())) {
        errors.pfaCI = "Format invalid (ex: RD 123456)";
      }
    }

    if (stepId === "beneficiar") {
      if (data.beneficiarPF) {
        if (!data.beneficiarNume.trim()) {
          errors.beneficiarNume = "Numele este obligatoriu";
        } else if (data.beneficiarNume.trim().split(/\s+/).length < 2) {
          errors.beneficiarNume = "Introduceti numele complet (nume si prenume)";
        }
        if (data.beneficiarCNP.trim() && !/^\d{13}$/.test(data.beneficiarCNP.trim())) {
          errors.beneficiarCNP = "CNP-ul trebuie sa contina exact 13 cifre";
        }
        if (data.beneficiarCI.trim() && !/^[A-Z]{2}\s?\d{6,7}$/i.test(data.beneficiarCI.trim())) {
          errors.beneficiarCI = "Format invalid (ex: MZ 654321)";
        }
        if (!data.beneficiarAdresa.trim()) errors.beneficiarAdresa = "Adresa este obligatorie";
      } else {
        if (!data.beneficiarDenumire.trim()) errors.beneficiarDenumire = "Denumirea societatii este obligatorie";
        if (!data.beneficiarCUI.trim()) {
          errors.beneficiarCUI = "CUI-ul este obligatoriu";
        } else if (!/^(RO)?\d{2,10}$/i.test(data.beneficiarCUI.trim())) {
          errors.beneficiarCUI = "Format invalid (ex: RO12345678)";
        }
        if (!data.beneficiarSediu.trim()) errors.beneficiarSediu = "Sediul social este obligatoriu";
        if (!data.beneficiarReprezentant.trim()) {
          errors.beneficiarReprezentant = "Reprezentantul legal este obligatoriu";
        } else if (data.beneficiarReprezentant.trim().split(/\s+/).length < 2) {
          errors.beneficiarReprezentant = "Introduceti numele complet (nume si prenume)";
        }
      }
    }

    if (stepId === "obiect") {
      if (!data.obiectContract.trim()) errors.obiectContract = "Descrierea serviciilor este obligatorie";
    }

    if (stepId === "financiar") {
      if (!data.tarifSuma || Number(data.tarifSuma) <= 0) {
        errors.tarifSuma = "Tariful este obligatoriu si trebuie sa fie pozitiv";
      }
    }

    if (stepId === "durataClauze") {
      if (!data.dataInceput) errors.dataInceput = "Data de inceput este obligatorie";
      if (!data.durataNedeterminata && !data.dataSfarsit) errors.dataSfarsit = "Data de sfarsit este obligatorie";
    }

    return errors;
  },
};

export default colaborarePFAConfig;
